import AllRoles from './AllRoles';

const titles = {
  LoyaltyApp: 'LoyaltyApp',
};

export const LoyaltyApp = [
  {
    component: 'Ads',
    path: '/loyalty-app/ads',
    title: titles.LoyaltyApp,
    key: 'ads',
    subkeys: ['/loyalty-app/ads', '/loyalty-app/ads/add'],
    menu: 'Loyalty_App',
    submenu: "Ads",
    icon: 'OverviewIcon',
    parent: true,
    parenticon: 'SetupIcon',
    permission: [AllRoles.PRODUCT.PRODUCT],
  },
  {
    component: 'AddAds',
    path: '/loyalty-app/ads/add',
    title: titles.LoyaltyApp,
    key: 'ads',
    menu: 'Loyalty_App',
    submenu: "Ads",
    icon: 'OverviewIcon',
    parent: false,
    permission: [AllRoles.PRODUCT.PRODUCT],
  },
  {
    component: 'EditAds',
    path: '/loyalty-app/ads/:id',
    title: titles.LoyaltyApp,
    key: 'ads',
    menu: 'Loyalty_App',
    submenu: "Ads",
    icon: 'OverviewIcon',
    parent: false,
    permission: [AllRoles.PRODUCT.PRODUCT],
  },
  {
    component: 'Rewards',
    path: '/loyalty-app/rewards',
    title: titles.LoyaltyApp,
    key: 'rewards',
    subkeys: ['/loyalty-app/rewards', '/loyalty-app/rewards/add'],
    menu: 'Loyalty_App',
    submenu: "Rewards",
    icon: 'OverviewIcon',
    parent: true,
    parenticon: 'SetupIcon',
    permission: [AllRoles.PRODUCT.PRODUCT],
  },
  {
    component: 'AddRewards',
    path: '/loyalty-app/rewards/add',
    title: titles.LoyaltyApp,
    key: 'rewards',
    menu: 'Loyalty_App',
    submenu: "Rewards",
    icon: 'OverviewIcon',
    parent: false,
    permission: [AllRoles.PRODUCT.PRODUCT],
  },
  {
    component: 'EditRewards',
    path: '/loyalty-app/rewards/:id',
    title: titles.LoyaltyApp,
    key: 'rewards',
    menu: 'Loyalty_App',
    submenu: "Rewards",
    icon: 'OverviewIcon',
    parent: false,
    permission: [AllRoles.PRODUCT.PRODUCT],
  },
]